import { useQuery } from "@tanstack/react-query";
import { stripeApiService } from "../services/stripeApiService";
import { fromStripeConnectionDtoToStripeConnection } from "../types/stripeTypes";

export const stripeKeys = {
  all: ["stripe"] as const,
  detail: (businessId: string, userId: string) => [...stripeKeys.all, businessId, userId] as const,
};
export const stripeConnectionOptions = (businessId: string, userId: string) => ({
  queryKey: stripeKeys.detail(businessId, userId),
  queryFn: async ({ signal }: { signal: AbortSignal }) => fromStripeConnectionDtoToStripeConnection(await stripeApiService.getByBusinessId(businessId, signal)),
  staleTime: 0,
  retry: false,
});
export const useStripeConnection = (businessId: string, userId: string) => useQuery(stripeConnectionOptions(businessId, userId));
